import React from 'react';
import { withRouter } from 'react-router';
import BrandList from './BrandList';
import VehicleSelection from './VehicleSelection';
import SizeSelection from './SizeSelection';
import SizeSelectionWheels from './SizeSelectionWheels';
import '../statics/stylesheet.css';

class Options extends React.Component {

  render() {
    const props = this.props;
    const { params } = this.props;
    const { category, search_by } = params;

    if (search_by === 'Brand') {
      return <BrandList params={params} />;
    } else if (search_by === 'Vehicle') {
      return <VehicleSelection {...props} params={params} confirm={false} inSize={false} />;
    } else if (search_by === 'Size') {
      if (category === 'Wheels') {
        return <SizeSelectionWheels params={params}/>;
      }
      if ( category === 'Tires') {
        return <SizeSelection params={params}/>;
      }
    }
    return <div>Category List is empty</div>;
  }
}

Options.propTypes = {
  params: React.PropTypes.object.isRequired
};

export default withRouter(Options);



// WEBPACK FOOTER //
// ./src/components/Options.js